import Button from '@sdb/ui/atoms/Button';
import { Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import { mutations, queries } from 'RestAPIs/rapini';
import { AxiosError } from 'axios';
import showSnackbar from 'components/shared/Snackbar';
import { StyledTile } from 'components/shared/Tile/Tile.styles';
import showError from 'components/shared/showError';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function BalanceBudgetGiftProcedure() {
  const { t } = useTranslation('common');
  const { data: lastLockedMonth } =
    queries.useSecureAdminProceduresLastLockedMonth();
  const currentYear = dayjs(lastLockedMonth?.lastLockedMonth).year();

  const { mutate, isLoading } =
    mutations.useSecureAdminProceduresBalanceBudgetGift();

  const onClick = async () => {
    mutate(
      {},
      {
        onSuccess: () => {
          showSnackbar({
            message: t('balanceBudgetGiftSuccess'),
            severity: 'success'
          });
        },
        onError: (e) => {
          showError(e as AxiosError);
        }
      }
    );
  };

  return (
    <StyledTile title={t('balanceBudgetGiftProcedure')}>
      <Typography
        variant="body2"
        sx={{ fontFamily: 'SourceSansPro-Regular', whiteSpace: 'pre-wrap' }}
      >
        {t('balanceBudgetGiftExplanation')}
      </Typography>
      <p>
        {t('currentOpenYear')}: {currentYear}
      </p>
      <Button variant="outlined" onClick={onClick} disabled={isLoading}>
        {isLoading && (
          <Icon
            type="spinner-scale"
            style={{ animation: 'fa-spin 2s infinite linear' }}
            sx={{ mr: 1 }}
          />
        )}
        {t('execute')}
      </Button>
    </StyledTile>
  );
}
